import { FC, useEffect } from 'react';
import { useI18n, useSelector } from '~Hooks';
import { buildOrderNumberSlip } from '~Components/PrinterManager/orderNumberSlip';

interface Props {
  /**
   * The order id this kiosk session is currently placing. state.POSReceiptPrints is a
   * single global slot that is never cleared after use (see CLEAR_RECEIPT), so without
   * this guard a fresh kiosk session that remounts this component would immediately
   * reprint whatever order-number ticket a previous, unrelated session last queued here.
   */
  orderId: string | null;
}

const OrderIdMaster: FC<Props> = ({ orderId }) => {
  const print = useSelector((state) => state.POSReceiptPrints);
  const order = useSelector((state) => print && state.POSOrders.find((o) => o.id === print.id));
  const { i18n } = useI18n();

  useEffect(() => {
    if (!print || print.id !== orderId || !order?.orderNumber || !order?.noReceipt) {
      return;
    }

    const message = buildOrderNumberSlip(order.orderNumber, i18n);

    window.printerManager?.initiatePrint({
      data: message,
      printType: 'EPOS_ORDER_NUMBER',
    });
  }, [print, order, orderId]);

  return null;
};

export default OrderIdMaster;
